
namespace Matrix.Indexation {
    export class IndexationProfileSecurityColumns {
        static columnsKey = 'Indexation.IndexationProfileSecurity';
    }
}